/* eslint-disable react-hooks/exhaustive-deps */
//#region Styles
import { Column, Row } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import TooltipButton from "components/TooltipButton/TooltipButton";
import RequiredInformationForm from "components/RequiredInformationForm/RequiredInformationForm";
import ChangeHistory from "../../components/ChangeHistory/ChangeHistory";
//#endregion
//#region Utils
import { ERROR_TEXT_LIST, GROUP_ROOM_SERVICE_TYPE_ID } from "../utils/constants";
import { RESOURCE_TEXT_LIST } from "views/Recursos/ResourcesLibrary/utils/constants";
import { WIDTH_SELECT_CONTROL, WIDTH_INPUT_TEXT_CONTROL } from "../../utils/constants";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useChangeLibraryListByCampus from "views/Recursos/ResourcesLibrary/utils/hooks/useChangeLibraryListByCampus";
import { regex } from "utils/validations";
import { useEffect } from "react";
//#endregion

const Fields = ({
    isAdmin,
    currentGroupRoomResourceForUpdate, 
    toggleShowDialogToggleActivationResource,
    form, errors, errorTexts,
    setCurrentResourceTypeIdToForm,
    data: {
        campusList,
        screenList,
        libraryList,
        resourceTypes
    },
    isCreate,
    loadingRequest
}) => {
    const { 
        name, campusId, libraryId, 
        resourceTypeId, capacity, 
        screenId, groupRoomOutOfLibrary, 
        environment, address,
        details, active } = form.value;
    useEffect(() => {
        if (!isCreate || screenList.length !== 1 || screenId) return;
        changeScreenIdField(screenList[0].id);
    }, [screenId]);
    //#region Functions
    const changeCampusField = value => {
        form.change("campusId", value);
    }
    const changeLibraryField = value => {
        form.change("libraryId", value);
    }
    const changeResourceTypeId = value => {
        form.change("resourceTypeId", value);
        setCurrentResourceTypeIdToForm(value);
    }
    const changeCapacityField = value => {
        form.change("capacity", value);
        checkCapacityErrors(value);
    }
    const changeScreenIdField = value => {
        form.change("screenId", value);
    }
    const changeEnvironmentField = value => {
        form.change("environment", value);
    }
    const changeAddressField = value => {
        form.change("address", value);
    }
    const changeDetailsField = value => {
        form.change("details", value);
    }
    const changeActiveField = () => {
        form.change("active", prev => !prev);
        toggleShowDialogToggleActivationResource(true);
    }
    const checkCapacityErrors = value => {
        if (regex.numbers.test(value) && !form.isValidCapacityNumber(value)) {
            errorTexts.change({
                capacity: ERROR_TEXT_LIST.CAPACITY.INVALID_FOR_LESS_THAN_2
            });
            errors.change({ capacity: true });
            return;
        }
        errors.change({ capacity: false });
    }
    //#endregion
    const { libraryListByCampus } = useChangeLibraryListByCampus({
        currentResourceForUpdate: currentGroupRoomResourceForUpdate,
        campusId,
        changeLibraryField,
        libraryList
    });
    const textService = RESOURCE_TEXT_LIST[GROUP_ROOM_SERVICE_TYPE_ID];
    return (
        <Container className="custom-scrollbar primary">
            <Row justifyContent="flex-start">
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Campus"
                    value={campusId}
                    optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                    onChange={changeCampusField}
                    defaultOptionText="Elige un Campus"
                    disabled={!isCreate || !isAdmin}
                    required={isCreate}/>
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Biblioteca"
                    value={libraryId}
                    optionsProps={getOptionsToCustomSelect(libraryListByCampus, { id: "id", text: "name" })}
                    onChange={changeLibraryField}
                    defaultOptionText="Elige una Biblioteca"
                    disabled={!isCreate || libraryListByCampus.length === 0}
                    required={isCreate}/>
                <CustomSelect 
                    width={WIDTH_SELECT_CONTROL}
                    label="Recurso"
                    value={resourceTypeId}
                    optionsProps={getOptionsToCustomSelect(resourceTypes, { id: "id", text: "name" })}
                    onChange={changeResourceTypeId}
                    defaultOptionText="Elige un Recurso"
                    disabled={!isCreate}
                    required={isCreate}/>
            </Row>
            <Row justifyContent="flex-start">
                <CustomTextInput 
                    {...WIDTH_INPUT_TEXT_CONTROL}
                    label="Nombre del recurso"
                    value={name || "-"}
                    disabled/>
                <CustomTextInput 
                    {...WIDTH_INPUT_TEXT_CONTROL}
                    label="Cantidad máxima de alumnos"
                    placeholder="Ej: 7"
                    value={capacity}
                    onChange={changeCapacityField}
                    onKeyPress={handlerKeyPressOnlyNumbers}
                    maxLength={3}
                    error={errors.value.capacity}
                    errorText={errorTexts.value.capacity}
                    required/>
                <CustomSelect 
                    {...WIDTH_SELECT_CONTROL}
                    label="Pantalla"
                    value={screenId}
                    onChange={changeScreenIdField}
                    defaultOptionText="Elige una Pantalla"
                    optionsProps={getOptionsToCustomSelect(screenList, { id: "id", text: "name" })}
                    disabled={screenList.length < 2}
                    required/>
            </Row>
            <CustomCheckbox 
                label="La sala grupal se encuentra fuera de la biblioteca"
                checked={groupRoomOutOfLibrary}
                onChange={form.toggleGroupRoomOutOfLibrary}
                padding="0"
                disabled={!isCreate}/>
            <Row width="100%" columnGap="5px">
                <CustomTextInput 
                    width="49%"
                    minWidth="300px"
                    label="Ambiente"
                    placeholder="Indica el nombre del ambiente"
                    value={environment}
                    onChange={changeEnvironmentField}
                    maxLength={50}
                    disabled={!groupRoomOutOfLibrary}
                    required={groupRoomOutOfLibrary}/>
                <CustomTextInput 
                    width="49%"
                    minWidth="300px"
                    label="Dirección"
                    placeholder="Indica la dirección del ambiente"
                    value={address}
                    onChange={changeAddressField}
                    maxLength={200}
                    disabled={!groupRoomOutOfLibrary}/>
            </Row>
            <CustomTextArea 
                label="Detalles (opcional)"
                placeholder="Verás detalles del último uso"
                value={details}
                onChange={changeDetailsField}
                height="60px"
                showCharCounter={false} 
                maxLength={300}/>
            <Row width="100%" justifyContent={isAdmin ? "space-between" : "flex-end"}>
                {isAdmin &&
                <Row justifyContent="flex-start" gap="5px">
                    <CustomCheckbox 
                        variant="switch"
                        size="10px" 
                        label="Activo"
                        labelColor="var(--light-gray-4)"
                        checked={active}
                        onChange={changeActiveField}
                        disabled={isCreate}/>
                    <TooltipButton 
                        message={`Recuerda que podrás activar o desactivar la ${textService.minus.singular}.`}/>
                </Row>}
                <Column width="max-content" align="flex-end">
                    {(!isCreate && form.value.id) && 
                    <ChangeHistory 
                        resource={{
                            id: form.value.id,
                            resourceTypeId,
                            name
                        }}
                        loadingRequest={loadingRequest}/>}
                    <RequiredInformationForm/> 
                </Column>
            </Row>
        </Container>
    );
}

export default Fields;